import CustomersOverview from './customers-overview';

export default function HelicopterServiceProvidersOverview() {
  return <CustomersOverview variant="heli-provider" />;
}
